











import { Vue, Component, Prop } from 'vue-property-decorator';

import AppleLoginButton from '~/components/lists/items/AppleLoginButton.vue';
import FacebookLoginButton from '~/components/lists/items/FacebookLoginButton.vue';
import GoogleLoginButton from '~/components/lists/items/GoogleLoginButton.vue';

@Component({
  components: {
    AppleLoginButton,
    FacebookLoginButton,
    GoogleLoginButton,
  },
})
export default class SocialSign extends Vue {
  @Prop(String) title: '';
}
